import React, { useCallback, useState } from "react";
import { ButtonWithCruiseCounterLabel } from "../ButtonWithCruiseCounter";
import ModalFilters, { ModalFiltersProps } from "./ModalFilters";
import { useCurrentRefinements } from "react-instantsearch";
import { Button } from "@silversea-ssc/ui-components-react";

type Props = ModalFiltersProps & {
  label: ButtonWithCruiseCounterLabel;
};

const attributeFiltersToIgnore = [
  "countryNames",
  "portNames",
  "destinationName",
  "departureYearMonth"
];

const OpenModalFiltersButton: React.FC<Props> = ({ label, ...props }) => {
  const { items } = useCurrentRefinements();
  const [modalIsMounted, setModalIsMounted] = useState(false);
  const [modalIsVisible, setModalIsVisible] = useState(false);

  const activeFilters = items
    .map((i) => i.attribute)
    .filter((s) => !attributeFiltersToIgnore.includes(s));

  const openFilterModal = useCallback(() => {
    setModalIsMounted(true);
    setModalIsVisible(true);
  }, []);

  return (
    <React.Fragment>
      <Button
        renderAs="button"
        variant="inline-text"
        type="button"
        iconName="filters"
        onClick={openFilterModal}
        dataContentPiece="open_filters_modal"
      >
        {label(activeFilters.length ?? 0, 0)}
      </Button>
      {modalIsMounted && (
        <ModalFilters
          {...props}
          modal={{
            onRequestClose: () => setModalIsVisible(false)
          }}
          isVisible={modalIsVisible}
          dataContentName="modal_filters"
        />
      )}
    </React.Fragment>
  );
};

export default OpenModalFiltersButton;
